import React, { useState } from "react";
import UI from "@mile-meeting/mile-ui";
import styled from "@emotion/styled";

interface RoomCapacityFieldProps {
  capacity: number;
  onChange: (value: number) => void;
  disabled?: boolean;
}

export const RoomCapacityField: React.FC<RoomCapacityFieldProps> = ({ capacity = 0, onChange, disabled = false }) => {
  const [value, setValue] = useState(capacity);

  const handleChange = (value: string) => {
    if (/^\d*$/.test(value)) {
      onChange?.(parseInt(value));
      setValue(parseInt(value));
    }
  };

  return (
    <Container>
      <UI.Typography type="label01" fontStyle="bold" color="var(--alias-color-label-alternative)">
        회의실 수용 인원 <RequiredAsterisk>*</RequiredAsterisk>
      </UI.Typography>
      <InputWrapper>
        <UI.Input
          disabled={disabled}
          helpText="회의실 수용 인원은 최대 1,000명까지 입력 가능합니다."
          error={value > 1000 ? true : false}
          showHelpText={value > 1000 ? true : false}
          placeholder="수용 인원 (숫자)"
          showPrefixIcon
          prefixIcon="people"
          width={498}
          value={value >= 1 ? `${value}` : ""}
          onChange={handleChange}
        />
        <UI.Typography type="body01 normal" fontStyle="regular" color="var(--alias-color-label-normal)">
          명
        </UI.Typography>
      </InputWrapper>
    </Container>
  );
};

export default React.memo(RoomCapacityField);

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const RequiredAsterisk = styled.span`
  color: var(--alias-color-primary-normal);
`;

const InputWrapper = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  cursor: pointer;
`;
